module.exports = __webpack_public_path__ + "img/oni_tab_highlight.bced7357.png";